const REG_EXP_NORMALIZE = new RegExp(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/, "gi")

export function normalizeName(name, replaceSpacesWith= "-") {
    if (name !== undefined) {
        return name.normalize("NFD")
            .replace(REG_EXP_NORMALIZE, "$1")
            .normalize().toLowerCase()
            .replace(/ /g, replaceSpacesWith)
    }
    return name
}

export function removeAccents(str) {
    if (str !== undefined) {
        return str.normalize("NFD")
            .replace(REG_EXP_NORMALIZE, "$1")
            .normalize()
    }
    return str
}


export function plurifyFirstWord(subtipo){
    let str = subtipo.split(" ")[0]
    str = removeAccents(str) + ((new RegExp("[aeiou]$").test(str)) ? "s" : "es")
    return (str + " " + subtipo.split(" ").slice(1).join(" ")).trim()
}

export function capitalizeFirstLetter(word){
    return word.charAt(0).toUpperCase() + word.slice(1)
}
